import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ds-report-progress',
  templateUrl: './report-progress.component.html',
  styleUrls: ['./report-progress.component.scss']
})
export class ReportProgressComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
